export default [
  {
    path: '/pages/authentication',
    name: 'page-register',
    component: () => import('./Register.vue'),
    meta: {unused: true}
  },
  {
    path: '/pages/authentication/login-v1', // login fields in the center
    name: 'auth-login-v1',
    component: () => import('./Login-v1.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
  {
    path: '/pages/authentication/login-v2', // login fields on the right
    name: 'auth-login-v2',
    component: () => import('./Login-v2.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
  {
    path: '/pages/authentication/register-v2', // sign up. input fields on the right
    name: 'auth-register-v2',
    component: () => import('./Register-v2.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
  {
    path: '/pages/authentication/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('./ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      unused: true
      // redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/forgot-password-v1', // input fields in the center
    name: 'auth-forgot-password-v1',
    component: () => import('./ForgotPassword-v1.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
  {
    path: '/pages/authentication/forgot-password-v2', // input fields on the right
    name: 'auth-forgot-password-v2',
    component: () => import('./ForgotPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      unused: true
    },
  },
  {
    path: '/pages/authentication/reset-password-v1', // input fields in the center
    name: 'auth-reset-password-v1',
    component: () => import('./ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
  {
    path: '/pages/authentication/reset-password-v2', // input fields on the right
    name: 'auth-reset-password-v2',
    component: () => import('./ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
      unused: true
    },
  },
]